import { ApiResponse } from 'types/api';

import { apiRequest } from 'services/api/client';

export type UnsubscribeRequest = {
  first_name: string;
  last_name: string;
  email: string;
  iban_last_5: string;
};

export type PurchaseSubscriptionRequest = {
  plan_name: string;
  price: number;
};

export type CreatePaymentSessionRequest = {
  plan_id: number;
  plan_name: string;
  amount: number;
  first_name: string;
  last_name: string;
  email: string;
  country: string;
  address?: string;
  city?: string;
  postal_code?: string;
  phone?: string;
};

export type CreatePaymentSessionResponse = {
  sessionToken: string;
};

export type ValidateIbanRequest = {
  session_token?: string;
  iban: string;
};

export type ValidateIbanResponse = {
  valid: boolean;
  bankName: string | null;
  bic: string | null;
  message: string | null;
};

export type SubmitPaymentRequest = {
  session_token: string;
  iban: string;
  iban_holder_name: string;
};

export type VerifyPaymentRequest = {
  session_token: string;
  verification_id?: string;
};

export type PaymentFlowResponse = {
  sessionToken: string;
  status: string;
  retryAllowed: boolean;
  verificationUrl: string | null;
  message: string | null;
  subscriptionActive: boolean;
};

export const subscriptionService = {
  unsubscribe(payload: UnsubscribeRequest) {
    return apiRequest<ApiResponse<Record<string, unknown>>>('/subscriptions/unsubscribe', {
      method: 'POST',
      body: payload,
    });
  },

  purchase(payload: PurchaseSubscriptionRequest) {
    return apiRequest<ApiResponse<Record<string, unknown>>>('/subscriptions/purchase', {
      method: 'POST',
      body: payload,
      auth: true,
    });
  },

  createPaymentSession(payload: CreatePaymentSessionRequest) {
    return apiRequest<ApiResponse<CreatePaymentSessionResponse>>('/subscriptions/create-payment-session', {
      method: 'POST',
      body: payload,
      auth: true,
    });
  },

  validateIban(payload: ValidateIbanRequest) {
    return apiRequest<ApiResponse<ValidateIbanResponse>>('/subscriptions/validate-iban', {
      method: 'POST',
      body: payload,
    });
  },

  submitPayment(payload: SubmitPaymentRequest) {
    return apiRequest<ApiResponse<PaymentFlowResponse>>('/subscriptions/submit-payment', {
      method: 'POST',
      body: payload,
      auth: true,
    });
  },

  verifyPayment(payload: VerifyPaymentRequest) {
    return apiRequest<ApiResponse<PaymentFlowResponse>>('/subscriptions/verify-payment', {
      method: 'POST',
      body: payload,
      auth: true,
    });
  },
};
